(() => {
  if (window.rbPillowGiftGuard) return;
  const baseFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const giftLabel = document.currentScript?.dataset.giftLabel || 'Free gifts included';
  const giftValue = document.currentScript?.dataset.giftValue || 'Satin sleep mask + e-book — FREE';
  const isPillow = item => /^restingbelly-maternity-pillow(?:-\d+)?$/.test(item.handle || '');
  let pending = null;
  let timer = null;
  const render = cart => {
    if (cart.sections?.['cart-drawer']) {
      const drawer = document.querySelector('cart-drawer');
      const section = drawer?.getSectionsToRender?.().find(item => item.id === 'cart-drawer');
      const current = document.querySelector('#CartDrawer');
      if (section && current) {
        const parsed = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
        const updated = parsed.querySelector('#CartDrawer');
        if (updated) {
          current.innerHTML = updated.innerHTML;
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
          if (drawer.classList.contains('active') && typeof trapFocus === 'function') {
            const focus = drawer.querySelector('.drawer__close');
            trapFocus(current, focus);
          }
        }
      }
      drawer?.classList.toggle('is-empty', cart.item_count === 0);
    }
    if (cart.sections?.['cart-icon-bubble']) {
      const icon = document.getElementById('cart-icon-bubble');
      const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
      const next = parsed.getElementById('shopify-section-cart-icon-bubble') || parsed;
      if (icon) icon.innerHTML = next.innerHTML;
    }
    if (document.querySelector('cart-items') && window.location.pathname.endsWith('/cart')) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-pillow-gift-guard', cartData: cart });
    }
  };
  const reconcile = () => {
    if (pending) return pending;
    pending = (async () => {
      const response = await baseFetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be refreshed.');
      let cart = await response.json();
      const updates = {};
      let keptGift = false;
      for (const item of cart.items || []) {
        if (item.properties?._rb_pillow_offer_gift !== 'true') continue;
        if (keptGift) updates[item.key] = 0;
        else {
          keptGift = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        }
      }
      if (Object.keys(updates).length) {
        const update = await baseFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        cart = await update.json();
        if (!update.ok) throw new Error('Cart could not be refreshed.');
        render(cart);
      }
      const lineCount = (cart.items || []).length;
      let giftDetailsChanged = false;
      for (let index = 0; index < lineCount; index += 1) {
        const item = (cart.items || []).find(line => isPillow(line) && (line.properties?.[giftLabel] !== giftValue || line.properties?._rb_checkout_gifts !== giftLabel));
        if (!item) break;
        const properties = { ...item.properties };
        const previousLabel = properties._rb_checkout_gifts;
        if (previousLabel && previousLabel !== giftLabel) delete properties[previousLabel];
        properties[giftLabel] = giftValue;
        properties._rb_checkout_gifts = giftLabel;
        const update = await baseFetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        cart = await update.json();
        if (!update.ok) throw new Error('Cart could not be refreshed.');
        giftDetailsChanged = true;
      }
      if (giftDetailsChanged) render(cart);
      return cart;
    })().finally(() => { pending = null; });
    return pending;
  };
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => reconcile().catch(() => {}), 200);
  };
  const showError = () => {
    const message = document.querySelector('rb-pillow-offer')?.dataset.error || 'Your cart could not be refreshed. Please try again.';
    const error = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (error) {
      error.textContent = message;
      error.setAttribute('role', 'alert');
    }
  };
  window.rbPillowGiftGuard = { reconcile };
  window.fetch = async (input, init) => {
    const response = await baseFetch(input, init);
    const url = typeof input === 'string' ? input : input?.url || '';
    if (response.ok && /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url)) schedule();
    return response;
  };
  document.addEventListener('rb:cart-drawer-rendered', schedule);
  window.addEventListener('pageshow', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout' || form.dataset.rbPillowChecked === 'true') return;
    event.preventDefault();
    reconcile().then(() => {
      const currentForm = (form.id && document.getElementById(form.id)) || form;
      const submitter = (event.submitter?.id && document.getElementById(event.submitter.id)) || event.submitter;
      currentForm.dataset.rbPillowChecked = 'true';
      currentForm.requestSubmit(submitter);
      delete currentForm.dataset.rbPillowChecked;
    }).catch(showError);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !/\/checkout(?:[/?#]|$)/.test(link.getAttribute('href'))) return;
    event.preventDefault();
    reconcile().then(() => window.location.assign(link.href)).catch(showError);
  }, true);
})();
